import { applySnapshot, flow, types } from "mobx-state-tree";

import api from "services/api";

import { SimpleModel, FOOD_PROGRAM_TYPES } from "constants/models";

const FoodProgramWithItems = types
  .model({
    foodProgramType: types.string,
    items: types.array(SimpleModel),
  })
  .views(self => ({
    get options() {
      return self.items.map(({ id, name }) => ({ value: { id }, label: name }));
    },
  }));

const FoodActiveProgramDictionary = types
  .model({
    foodPrograms: types.array(FoodProgramWithItems),
    isLoading: types.optional(types.boolean, false),
  })
  .views(self => ({
    getOptionsByFoodProgram(foodProgramType?: string) {
      const foodProgramToFind = foodProgramType || FOOD_PROGRAM_TYPES.UNKNOWN;

      return self.foodPrograms.find(
        ({ foodProgramType }) => foodProgramType === foodProgramToFind,
      )?.options;
    },
  }))
  .actions(self => ({
    fetch: flow(function*(programType?: string) {
      self.isLoading = true;

      try {
        const { items } = yield api.get(`/active-program/food/list`, {
          foodProgramType: programType,
        });
        const foodProgram = {
          foodProgramType: programType ?? "default",
          items,
        };

        applySnapshot(self, {
          ...self,
          foodPrograms: [...self.foodPrograms, foodProgram],
        });
      } catch (error) {
        console.log("error :>> ", error);
        throw error;
      } finally {
        self.isLoading = false;
      }
    }),
  }))
  .actions(self => ({
    init: flow(function*() {
      yield self.fetch(FOOD_PROGRAM_TYPES.UNKNOWN);
      yield self.fetch(FOOD_PROGRAM_TYPES.SIX_WEEK);
      yield self.fetch(FOOD_PROGRAM_TYPES.VIP_AND_OTHER);
    }),

    reset() {
      applySnapshot(self, { foodPrograms: [] });
    },
  }));

export default FoodActiveProgramDictionary.create();
